// Mapeo de IDs largos a equivalentes (A1, A2, B1, etc.)
const idMapping = {
  // Serie A
  "4tcpns1nwyc0jtpucgzj9dp90": "A1",
  "9hjlhmip7tn4qgpwr47txpafo": "A2",
  "cbn3r0bwd3283f8bj4vuvifis": "A3",
  "bdoe50pj6ug3jrc5to1j8st1w": "A4",
  "d7gajq1bxb1xtvqbuxivlk4r8": "A5",
  "ec5p7nsiix511225m4yfqt250": "A6",
  
  // Serie B
  "y1ow9ht5baxn64i01hq9moes": "B1",
  "2lzhf44ic9g2dj0l29fji2xw4": "B2",
  "4mov5r6nivdn6dhlmb9hv5q1g": "B3",
  "3luqmzpzk0qoh2tc96utv0ges": "B4",
  "5irko4jg9o9ixmfz8cu3oxjpw": "B5",
  "6eub9tlno07el5y4ajvumqqdw": "B6",
  
  // Serie C
  "ar8b186wqraa80u0vpi2e4nis": "C1",
  "cydmo9vjfyvaefav6t1531xck": "C2",
  "exuljwp9gd116hkf5sox4q5g4": "C3",
  "e6dmlhi5t34w58liv12sp591w": "C4",
  "spvh4xw4rpclalcf1jhsrv2s": "C5",
  "1r744e2q8r9lfwjz888dzxmac": "C6",
  
  // Serie D
  "49wa9ymnt0trv2mjruak556ok": "D1",
  "5d1c5lu90p9hhk82c0kcp05qs": "D2",
  "6dt4a73k05gldmswzc3tgxmvo": "D3",
  "7evssbq9air6phyr658hcanmc": "D4",
  "8chdphpgdqjkj85rml9odn1uc": "D5",
  "9784oivu7jkgn66e0pnnsyr6c": "D6",
  
  // Serie E
  "cjc09ujyfc1ks4blsyl8hbfv8": "E1",
  "ddupm8zbfndp54r8uru3obf9w": "E2",
  "ecp6v27q48jj6um9odhcahjbo": "E3",
  "9erlmm2s3kapioujs9clvcic": "E4",
  "2kh760gcb6c4liigtebtxtus4": "E5",
  "1ela50pkr7ho1l8kbj6a1di50": "E6",
  
  // Serie F
  "424kyd0drjm51x8dsauowgpp0": "F1",
  "4v4v3ge0g7tm1w9uzpoehmzh0": "F2",
  "5nh4gmpiskmsjcy904osi5n2s": "F3",
  "6c7t9tr9b24qfjwphblk6776c": "F4",
  "83o3gqwqwt5c9jskxmcpqjvv8": "F5",
  "77okx4j2kol5e0806b6xf74lw": "F6",
  
  // Serie G
  "aw4mhrfav7b5r7d4lc6dwz1g4": "G1",
  "c4kuk30dj016i6gjwxw4clnh0": "G2",
  "cz84ih3b6irraa24kj6kvtz4k": "G3",
  "ds4dbpzuq9s8a87zc84b58w7o": "G4",
  "ctfvqyihaptbye55z2v5jims": "G5",
  "enyd3pel1z18f8cikzixnwpw4": "G6",
  
  // Serie H
  "66cem7lh6o8ckkfxp4tao7o5w": "H1",
  "6zuh8kndp7mz2j33tqajmos2c": "H2",
  "8muyl6d5ahy04fbwarplcg3kk": "H3",
  "9ic1j3k1bvdhabxn5crvsx6ac": "H4",
  "bl0y9cpgj82lun5bhvz8r3u38": "H5",
  "ahb6v608gitlu543aevomjuac": "H6",
  
  // Serie I
  "cqsflhc7vaul90l2d4ipzzzmc": "I1",
  "dk9nrrzts19sez2hpbxx7soic": "I2",
  "emsvcmkqvohy5qmhedopxtus4": "I3",
  "elv88zog1n9ratzzksyfumtw": "I4",
  "2bi32jvwjtru3nrkulzx3ip04": "I5",
  "1fxxfshtg3b7p2ya8789tke8k": "I6",
  
  // Serie J
  "55108ze2r7d8dgkmcauepuhp0": "J1",
  "67uqo1wgdcka1yxqltbiqxn9w": "J2",
  "6zhd6pt8kyzrbkgwq2i2k8u1g": "J3",
  "7mw80b82sfqh1le7swr7l8zdg": "J4",
  "94kik3fjes44gzerha1wu2l90": "J5",
  "8g2qr1sd0kqxtjcvybdfgzvh0": "J6",
  
  // Serie K
  "aa59tfi9hkmjec05olroia13o": "K1",
  "b6gp5y32kvgossb0feqipr8r8": "K2",
  "bwetcq2x65uyp68uztwcuw9hw": "K3",
  "csme1qixbyobvbac3o0td9uz8": "K4",
  "dsi0ga8gcy8xcrywdfj3i51qs": "K5",
  "emz36epmepynr3ggfksojdmhg": "K6",
  
  // Serie L
  "jx85i5ao3wvsb8opsu0ic1sk": "L1",
  "1ewge3gy7siiimkd64tawg1zo": "L2",
  "28702hpanr32no1vpxmxhbok4": "L3",
  "2ypodyawtamo2zzadwm42g9hw": "L4",
  "3t13xxgisfsmlvm62iydvpqms": "L5",
  "4n1jg6og0392ta1ncdefsn2tw": "L6"
};

/**
 * Convierte un ID largo a su equivalente (A1, A2, etc.)
 * @param {string} longId - El ID largo a convertir
 * @returns {string} - El equivalente o el ID original si no está en el mapeo
 */
export const getLongIdEquivalent = (longId) => {
  return idMapping[longId] || longId;
};

/**
 * Convierte un equivalente (A1, A2, etc.) a su ID largo
 * @param {string} equivalent - El equivalente a convertir
 * @returns {string} - El ID largo o el equivalente original si no está en el mapeo
 */
export const getEquivalentLongId = (equivalent) => {
  // Crear un mapeo inverso
  const reverseMapping = {};
  Object.entries(idMapping).forEach(([longId, equiv]) => {
    reverseMapping[equiv] = longId;
  });
  return reverseMapping[equivalent] || equivalent;
};

/**
 * Reemplaza todos los IDs largos en un objeto por sus equivalentes
 * Reemplaza tanto claves como valores
 * @param {object} data - El objeto a procesar
 * @param {array} keysToReplace - Las claves donde buscar IDs (opcional)
 * @returns {object} - El objeto con IDs reemplazados
 */
export const replaceAllLongIds = (data, keysToReplace = null) => {
  if (typeof data !== 'object' || data === null) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map(item => replaceAllLongIds(item, keysToReplace));
  }

  const result = {};
  Object.entries(data).forEach(([key, value]) => {
    // Reemplazar la clave si es un ID largo
    const newKey = idMapping[key] || key;
    
    if (typeof value === 'string' && idMapping[value]) {
      // Si el valor es un ID largo, reemplazarlo
      result[newKey] = idMapping[value];
    } else if (typeof value === 'object' && value !== null) {
      // Si es un objeto/array, procesarlo recursivamente
      result[newKey] = replaceAllLongIds(value, keysToReplace);
    } else {
      // Mantener el valor tal cual
      result[newKey] = value;
    }
  });

  return result;
};

export default {
  idMapping,
  getLongIdEquivalent,
  getEquivalentLongId,
  replaceAllLongIds
};